/**
 *   Brochure Download
**/

//show overlay form
$('.brochure-download').click(function(e){

	e.preventDefault();

	$('.c-brochure_form_wrap').addClass('active');

	$('body').addClass('c-body-active');

	

});

//remove overlay form
$('.c-close-form').click(function(e){

	e.preventDefault();

	$('.c-brochure_form_wrap').removeClass('active');

	$('body').removeClass('c-body-active');

});

